import { IRatingScaleProps } from './IRatingScaleProps';
import { RatingScaleNumber } from './RatingScaleNumber';

/** ПСТЗ (численное значение вводимое вручную, не может быть выше 5, округление до сотых) */
export const RatingScalePSTZ = (props: IRatingScaleProps) => (
    <RatingScaleNumber {...props} scaleClassName="offer-crit-rating-scale-pstz" />
);
